import { useEffect } from 'react';
import useCurrentSettings from 'src/hooks/useCurrentSettings';
import useVelocityStore from 'src/stores/VelocityStore/useVelocityStore';

/**
 * Syncs the tradeform slippage tolerance with the global slippage tolerance
 */
export const useSyncGlobalSlippageTolerance = () => {
	const setState = useVelocityStore((s) => s.set);
	const [currentSettings] = useCurrentSettings();
	const { slippageTolerance: globalSlippageTolerance } = currentSettings;

	useEffect(() => {
		setState((s) => {
			s.tradeForm.slippageTolerance =
				globalSlippageTolerance === 'dynamic'
					? 'dynamic'
					: Number(globalSlippageTolerance);
		});
	}, [globalSlippageTolerance]);
};
